import { useEffect, useState } from 'react';
import { api, ApiError } from '../lib/api';
import { qtyLine } from '../lib/format';
import { MetricCard } from '../components/ui/KpiCard';

interface StockMove { day: string; kind: string; item: string; qty: number; }
interface MyStockData {
  client: string; stock: Record<string, number>; autonomy_days: number | null; recent: StockMove[];
}

export function MyStock() {
  const [data, setData] = useState<MyStockData | null>(null);
  const [error, setError] = useState('');

  async function load() {
    setError('');
    try { setData(await api<MyStockData>('/v1/my/stock')); }
    catch (e) { setError(e instanceof ApiError ? e.message : 'Erreur de chargement.'); }
  }
  useEffect(() => { load(); }, []);

  return (
    <>
      <div className="pagehead">
        <h1>Mon stock</h1>
        <div className="actions"><button className="small" onClick={load}>Actualiser</button></div>
      </div>
      <div className="card">
        {error && <div className="err">{error}</div>}
        {!data && !error && <div className="muted">Chargement...</div>}
        {data && (
          <>
            <div className="grid2">
              <MetricCard label="Client" value={data.client} />
              <MetricCard label="Stock" value={qtyLine(data.stock)} />
              <MetricCard label="Autonomie" value={data.autonomy_days != null ? data.autonomy_days.toFixed(1) + ' j' : '—'} />
            </div>
            {data.recent?.length > 0 && (
              <div className="tblwrap">
                <table style={{ marginTop: '1rem' }}>
                  <tbody>
                    <tr><th>Jour</th><th>Type</th><th>Caisse</th><th>Qté</th></tr>
                    {data.recent.slice().reverse().map((m, i) => (
                      <tr key={i}><td>{m.day}</td><td>{m.kind}</td><td>{m.item}</td><td>{m.qty}</td></tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}
